import { styled } from '@linaria/react';

export const Action = styled.div`
	margin: 28px auto 0;
`;
